import { render, staticRenderFns } from "./password-form.vue?vue&type=template&id=317bbd84"
import script from "./password-form.vue?vue&type=script&lang=js"
export * from "./password-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('317bbd84')) {
      api.createRecord('317bbd84', component.options)
    } else {
      api.reload('317bbd84', component.options)
    }
    module.hot.accept("./password-form.vue?vue&type=template&id=317bbd84", function () {
      api.rerender('317bbd84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/password-form.vue"
export default component.exports